import axios from 'axios';
import { ConsentHtmlSignDocumentData } from 'src/ts/interfaces/documents/consent-html-sign-document-data';

interface CreateSignEventParams {
  signRequestId: string;
  eventType: string;
  ipAddress: string;
  userAgent: string;
  geoLocation: object;
  metadata: object;
  quoteId?: string;
  patientName: string;
  email: string;
}

export const createSignEventService = async ({
  signRequestId,
  ipAddress,
  userAgent,
  geoLocation,
  metadata,
  eventType,
  quoteId,
  patientName,
  email,
}: CreateSignEventParams) => {
  try {
    const response = await axios.post(`/signdoc/create-sign-event`, {
      signRequestId,
      ipAddress,
      userAgent,
      geoLocation,
      metadata,
      eventType,
      quoteId,
      patientName,
      email,
    });

    const returnValue = response.data.data.htmlSignDocumentUpdated as ConsentHtmlSignDocumentData;
    return returnValue;
  } catch (error: any) {
    return 'verifyInvalid';
  }
};
